import Program from '@/shared/classes/epg/program/program'

const isProgram = (item: Program | null) => item as Program

export { isProgram }
